import React from 'react';
import { FiAlertCircle, FiLoader, FiInbox, FiClock } from 'react-icons/fi';
import './BackendPendingBanner.css';

/**
 * Uniform loading/error/empty/pending renderer for teacher widgets.
 *
 * `pending` means the backend endpoint exists as a stub or does not exist yet;
 * distinct from `empty`, which means the endpoint returned no rows.
 */
function BackendPendingBanner({ state, message, hint }) {
  const cfg = STATE_CONFIG[state] || STATE_CONFIG.empty;
  const Icon = cfg.icon;
  return (
    <div className={`backend-pending-banner backend-pending-banner--${state}`} role="status">
      <Icon size={18} className="backend-pending-banner__icon" aria-hidden="true" />
      <div className="backend-pending-banner__body">
        <p className="backend-pending-banner__message">{message || cfg.defaultMessage}</p>
        {hint && <p className="backend-pending-banner__hint">{hint}</p>}
      </div>
    </div>
  );
}

const STATE_CONFIG = {
  loading: { icon: FiLoader, defaultMessage: 'Loading…' },
  error: { icon: FiAlertCircle, defaultMessage: 'Something went wrong.' },
  empty: { icon: FiInbox, defaultMessage: 'Nothing here yet.' },
  pending: { icon: FiClock, defaultMessage: 'Backend endpoint pending.' },
};

export default BackendPendingBanner;
